import router from '@/router'
import store from '@/store'
import Auth from '@/utils/auth'

router.beforeEach((to, from, next) => {
  if (to.meta.title !== undefined) {
    document.title = to.meta.title + ' - 九州云管理后台';
  }
  console.log(Auth.getToken())
  if (Auth.getToken()) {
    if (to.path === '/login') {
      next('/');
    }
    if (store.getters.getMenuPermissions.length === 0) {
      store.dispatch('GetCurrentAdmin').then(res => {
        const current_shop_role_menus = ['10001', '10002', '10003', '10004', '10005', '10006', '10007', '10008'];
        if (res.channel_id === 0) {
          current_shop_role_menus.push('10009');
          current_shop_role_menus.push('100090');
          current_shop_role_menus.push('100091');
          current_shop_role_menus.push('100092');
          current_shop_role_menus.push('100093');
        }
        const menuIDS = current_shop_role_menus.map(menu_id => {
          return parseInt(menu_id)
        });
        store.dispatch('SetPermissions', { menuIDS }).then(() => {
          router.addRoutes(store.getters.getMenuPermissions);
          next({ to, replace: true })
        });
      }).catch(error => {
        console.log(error);
      })
    }
    next()
  } else {
    if (to.path === '/login') {
      next();
    } else {
      next('/login')
    }
  }
})

router.afterEach(() => {

})



// WEBPACK FOOTER //
// ./src/router-guards.js